import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import Mark from '../../../domain/entities/Mark';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexMarksSuccess: {
      const result = action.payload as PaginatedResult<Mark>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
